import { z } from 'zod';

export const conditionalTransitionsControllerUpdatePathParamsSchema = z.object({
  id: z.string().uuid(),
});

export const conditionalTransitionsControllerUpdate200Schema = z.boolean();

export const conditionalTransitionsControllerUpdate400Schema = z.union([
  z.object({
    statusCode: z.enum(['400']),
    message: z.string(),
    type: z.enum(['InvalidData']),
    details: z.object({
      location: z.enum(['path', 'query', 'body']),
      explanation: z.object({
        issues: z.array(
          z
            .object({
              code: z.enum([
                'invalid_type',
                'invalid_literal',
                'custom',
                'invalid_union',
                'invalid_union_discriminator',
                'invalid_enum_value',
                'unrecognized_keys',
                'invalid_arguments',
                'invalid_return_type',
                'invalid_date',
                'invalid_string',
                'too_small',
                'too_big',
                'invalid_intersection_types',
                'not_multiple_of',
                'not_finite',
              ]),
              path: z.array(z.union([z.string(), z.number()])),
              message: z.string(),
            })
            .catchall(z.unknown()),
        ),
      }),
    }),
  }),
  z.object({
    statusCode: z.enum(['400']),
    message: z.string(),
    type: z.enum(['ForeignViolation']),
    details: z.object({ attributes: z.array(z.string()) }),
  }),
]);

export const conditionalTransitionsControllerUpdate401Schema = z.object({
  statusCode: z.enum(['401']),
  message: z.string(),
  type: z.enum(['Authentication']),
  details: z.object({
    reason: z.enum(['InvalidRequest', 'InvalidToken', 'Unauthorized']),
  }),
});

export const conditionalTransitionsControllerUpdate403Schema = z.object({
  statusCode: z.enum(['403']),
  message: z.string(),
  type: z.enum(['Authorization']),
  details: z.object({ reason: z.enum(['InsufficientScope']) }),
});

export const conditionalTransitionsControllerUpdate404Schema = z.object({
  statusCode: z.enum(['404']),
  message: z.string(),
  type: z.enum(['ObjectNotFound']),
  details: z.enum(['null']).nullable(),
});

export const conditionalTransitionsControllerUpdate409Schema = z.object({
  statusCode: z.enum(['409']),
  message: z.string(),
  type: z.enum(['UniqueViolation']),
  details: z.object({ attributes: z.array(z.string()) }),
});

export const conditionalTransitionsControllerUpdateMutationRequestSchema =
  z.union([
    z.object({
      destinationCardId: z.string().uuid().optional(),
      type: z.enum(['numberOfCorrectAnswers']),
      value: z.number().int(),
    }),
    z.object({
      destinationCardId: z.string().uuid().optional(),
      type: z.enum(['selectedOption']),
      value: z.string(),
    }),
  ]);

export const conditionalTransitionsControllerUpdateMutationResponseSchema =
  z.boolean();
